















import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import { TransferSchedule } from "@/shared/types";
import { getScheduleDescription } from "@/shared/components/contributionsV3/scheduleDescriptions";
import { useThemeStore } from "@/shared/store/theme";

@Component
export default class CancelConfirmationModal extends Vue {
  themeStore = useThemeStore();

  @Prop({required: true})
  cancelModalVisible: boolean;

  @Prop({required: true})
  schedule: TransferSchedule;

  get scheduleDescription (): string {
    return getScheduleDescription(this.schedule);
  }

  onCancel (): void {
    this.$emit("cancel");
  }

  onSubmit (): void {
    this.$emit("confirm-cancellation");
  }
}
